function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, transition } from "../../../styles/theme";
import Measure from 'react-measure';
var CONFIG = {
  duration: 0.3
};
var styles = StyleSheet.create({
  Panel: {},
  transitionContainer: {
    overflow: 'hidden',
    transition: "height ".concat(CONFIG.duration, "s ").concat(transition.easeOutFunction)
  }
});

var Panel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Panel, _React$Component);

  function Panel(props, context) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onToggle", function (event) {
      var isExpanded = !_this.state.isExpanded;

      if (event.target.tagName && event.target.tagName.toLowerCase() === 'input') {
        return;
      }

      _this.setState(function () {
        return {
          isExpanded: isExpanded
        };
      });

      if (_this.props.onToggle) {
        _this.props.onToggle(_this.props.id, isExpanded);
      }
    });

    _this.state = {
      isExpanded: !!props.isExpanded,
      contentContainerHeight: props.defaultContentHeight || 0
    };
    return _this;
  }

  _createClass(Panel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('isExpanded' in nextProps && nextProps.isExpanded !== this.props.isExpanded) {
        this.setState(function () {
          return {
            isExpanded: nextProps.isExpanded
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          bodyRole = _this$props.bodyRole,
          children = _this$props.children,
          disabled = _this$props.disabled,
          footer = _this$props.footer,
          header = _this$props.header,
          htmlAttributes = _this$props.htmlAttributes,
          id = _this$props.id,
          renderChildren = _this$props.renderChildren,
          renderFooter = _this$props.renderFooter,
          renderHeader = _this$props.renderHeader,
          rootClassName = _this$props.rootClassName,
          style = _this$props.style,
          Tag = _this$props.tag;
      var _this$state = this.state,
          isExpanded = _this$state.isExpanded,
          contentContainerHeight = _this$state.contentContainerHeight;
      var eventProps = disabled ? {} : {
        onKeyPress: this.onToggle,
        onClick: this.onToggle
      };
      return React.createElement(Tag, _extends({}, htmlAttributes, css(rootClassName, styles.Panel), {
        style: style,
        role: bodyRole
      }), (header || renderHeader) && React.createElement("div", _extends({}, eventProps, {
        "aria-expanded": isExpanded,
        role: "button",
        tabIndex: 0,
        "aria-controls": id
      }), header, !header && renderHeader && renderHeader({
        id: id,
        isExpanded: isExpanded,
        disabled: disabled
      })), React.createElement("div", _extends({
        id: id
      }, css(styles.transitionContainer), {
        style: {
          height: contentContainerHeight
        }
      }), React.createElement(Measure, {
        bounds: true,
        onResize: function onResize(_ref) {
          var height = _ref.bounds.height;
          return _this2.setState({
            contentContainerHeight: height
          });
        }
      }, function (_ref2) {
        var measureRef = _ref2.measureRef;
        return React.createElement("div", {
          ref: measureRef,
          "aria-expanded": isExpanded
        }, isExpanded && children, !children && renderChildren({
          id: id,
          isExpanded: isExpanded,
          disabled: disabled
        }));
      })), (footer || renderFooter) && React.createElement("div", _extends({}, eventProps, {
        "aria-expanded": isExpanded,
        tabIndex: -1
      }), footer, !footer && renderFooter && renderFooter({
        id: id,
        isExpanded: isExpanded,
        disabled: disabled
      })));
    }
  }]);

  return Panel;
}(React.Component);

_defineProperty(Panel, "defaultProps", {
  htmlAttributes: {},
  style: {},
  rootClassName: '',
  defaultContentHeight: 0,
  bodyRole: 'region',
  renderChildren: function renderChildren() {
    return null;
  },
  tag: 'li'
});

Panel.propTypes = {
  bodyRole: PropTypes.string,
  children: PropTypes.node,
  defaultContentHeight: PropTypes.number,
  disabled: PropTypes.bool,
  footer: PropTypes.node,
  header: PropTypes.node,
  htmlAttributes: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
  isExpanded: PropTypes.bool,
  onToggle: PropTypes.func,
  renderChildren: PropTypes.func,
  renderFooter: PropTypes.func,
  renderHeader: PropTypes.func,
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
export default Panel;